import "./utils/_utils";
import "./pages/_pages";

import $ from 'jquery'

$('body')